export default __webpack_public_path__ + "static/media/ibrahim.65015951.jpg";